import {
    INS_CHECKLIST_EYEBROW, INS_CHECKLIST_ITEM1, INS_CHECKLIST_ITEM2, INS_CHECKLIST_ITEM3,
    INS_CHECKLIST_ITEM4, INS_CHECKLIST_ITEM5, INS_CHECKLIST_ITEM6, INS_CHECKLIST_SUBTITLE, INS_CHECKLIST_TITLE,
    INS_CTA_BUTTON, INS_CTA_SUBTITLE, INS_CTA_TITLE,
    INS_FAQ_A1, INS_FAQ_A2, INS_FAQ_A3, INS_FAQ_A4, INS_FAQ_A5,
    INS_FAQ_EYEBROW, INS_FAQ_Q1, INS_FAQ_Q2, INS_FAQ_Q3, INS_FAQ_Q4, INS_FAQ_Q5,
    INS_FAQ_SUBTITLE, INS_FAQ_TITLE,
    INS_HELMET_DESCRIPTION, INS_HELMET_TITLE,
    INS_HERO_CTA_BOOK, INS_HERO_CTA_CALL, INS_HERO_EYEBROW, INS_HERO_SUBTITLE,
    INS_HERO_TITLE, INS_HERO_TITLE_ACCENT,
    INS_HERO_TRUST_LICENSED, INS_HERO_TRUST_BILINGUAL, INS_HERO_TRUST_FREE,
    INS_PROCESS_EYEBROW,
    INS_PROCESS_STEP1_DESC, INS_PROCESS_STEP1_TITLE,
    INS_PROCESS_STEP2_DESC, INS_PROCESS_STEP2_TITLE,
    INS_PROCESS_STEP3_DESC, INS_PROCESS_STEP3_TITLE,
    INS_PROCESS_STEP4_DESC, INS_PROCESS_STEP4_TITLE,
    INS_PROCESS_TITLE,
    INS_SERVICES_EYEBROW, INS_SERVICES_SUBTITLE, INS_SERVICES_TITLE,
    INS_SERVICE_ACA_DESC, INS_SERVICE_ACA_TITLE,
    INS_SERVICE_DENTAL_DESC, INS_SERVICE_DENTAL_TITLE,
    INS_SERVICE_HEALTH_DESC, INS_SERVICE_HEALTH_TITLE,
    INS_SERVICE_LIFE_DESC, INS_SERVICE_LIFE_TITLE,
    INS_SERVICE_MEDICARE_DESC, INS_SERVICE_MEDICARE_TITLE,
    INS_SERVICE_SUPPLEMENTAL_DESC, INS_SERVICE_SUPPLEMENTAL_TITLE,
} from "../types";

const en_insurance_page = {
    helmet: {
        [INS_HELMET_TITLE]: "Health, Life & ObamaCare insurance help | Linares Pro Corp",
        [INS_HELMET_DESCRIPTION]: "Bilingual help enrolling in ObamaCare (ACA), health insurance, life insurance, Medicare, dental, vision and supplemental plans. Compare quotes for free.",
    },
    section: {
        hero: {
            [INS_HERO_EYEBROW]: "Insurance services",
            [INS_HERO_TITLE]: "Coverage for your family,",
            [INS_HERO_TITLE_ACCENT]: "without the confusion.",
            [INS_HERO_SUBTITLE]: "We compare health, life, Medicare, dental and supplemental plans in English or Spanish — and help you enroll in the one that actually fits your budget.",
            [INS_HERO_CTA_BOOK]: "Get a free quote",
            [INS_HERO_CTA_CALL]: "Call now",
            [INS_HERO_TRUST_LICENSED]: "Licensed insurance agents",
            [INS_HERO_TRUST_BILINGUAL]: "English & Spanish",
            [INS_HERO_TRUST_FREE]: "Free enrollment help",
        },
        services: {
            [INS_SERVICES_EYEBROW]: "What we help with",
            [INS_SERVICES_TITLE]: "Every kind of coverage, one trusted team.",
            [INS_SERVICES_SUBTITLE]: "From Marketplace plans to life insurance and Medicare, we shop multiple carriers so you don't have to.",
            [INS_SERVICE_HEALTH_TITLE]: "Health insurance",
            [INS_SERVICE_HEALTH_DESC]: "Individual and family plans from top carriers — we compare deductibles, networks and copays side by side.",
            [INS_SERVICE_ACA_TITLE]: "ObamaCare / ACA Marketplace",
            [INS_SERVICE_ACA_DESC]: "We check if you qualify for premium tax credits and walk you through Healthcare.gov enrollment step by step.",
            [INS_SERVICE_LIFE_TITLE]: "Life insurance (Term & Whole)",
            [INS_SERVICE_LIFE_DESC]: "Protect your family with term or whole life coverage. We explain the difference in plain language and find the right fit.",
            [INS_SERVICE_MEDICARE_TITLE]: "Medicare assistance",
            [INS_SERVICE_MEDICARE_DESC]: "Original Medicare, Advantage, Supplement (Medigap) and Part D — we help seniors choose with confidence.",
            [INS_SERVICE_DENTAL_TITLE]: "Dental & vision",
            [INS_SERVICE_DENTAL_DESC]: "Standalone dental and vision plans that fill the gaps your medical plan leaves behind.",
            [INS_SERVICE_SUPPLEMENTAL_TITLE]: "Supplemental & accident",
            [INS_SERVICE_SUPPLEMENTAL_DESC]: "Cash-benefit plans for accidents, critical illness and hospital stays — extra protection when life surprises you.",
        },
        process: {
            [INS_PROCESS_EYEBROW]: "How it works",
            [INS_PROCESS_TITLE]: "Four simple steps to the right plan.",
            [INS_PROCESS_STEP1_TITLE]: "Free consultation",
            [INS_PROCESS_STEP1_DESC]: "Tell us about your family, your budget and any current coverage. We listen first.",
            [INS_PROCESS_STEP2_TITLE]: "Quotes & comparison",
            [INS_PROCESS_STEP2_DESC]: "We pull plans from multiple carriers and explain the real cost — premium, deductible and out-of-pocket max.",
            [INS_PROCESS_STEP3_TITLE]: "Enrollment",
            [INS_PROCESS_STEP3_DESC]: "We submit your application, including ACA subsidy paperwork, so coverage starts on time.",
            [INS_PROCESS_STEP4_TITLE]: "Year-round support",
            [INS_PROCESS_STEP4_DESC]: "ID cards, claim questions, life changes, renewal time — we stay your point of contact all year.",
        },
        checklist: {
            [INS_CHECKLIST_EYEBROW]: "Get ready",
            [INS_CHECKLIST_TITLE]: "What to bring to your appointment.",
            [INS_CHECKLIST_SUBTITLE]: "We'll confirm the exact list once we know what coverage you're looking for.",
            [INS_CHECKLIST_ITEM1]: "Government-issued ID for every person on the plan",
            [INS_CHECKLIST_ITEM2]: "Social Security numbers (or document numbers for non-citizens)",
            [INS_CHECKLIST_ITEM3]: "Estimated household income (pay stubs, last tax return, 1099s)",
            [INS_CHECKLIST_ITEM4]: "Current insurance card or policy info, if any",
            [INS_CHECKLIST_ITEM5]: "Employer coverage details, if it's offered to you",
            [INS_CHECKLIST_ITEM6]: "Immigration / residency documents (for ACA eligibility)",
        },
        faq: {
            [INS_FAQ_EYEBROW]: "Insurance FAQ",
            [INS_FAQ_TITLE]: "Common insurance questions.",
            [INS_FAQ_SUBTITLE]: "Don't see your question? Call us — we'll walk you through it.",
            [INS_FAQ_Q1]: "Do I have to pay anything to enroll?",
            [INS_FAQ_A1]: "Our enrollment help is free. You only pay your insurance premium, and many ACA clients qualify for subsidies that lower it significantly.",
            [INS_FAQ_Q2]: "When can I enroll in ObamaCare?",
            [INS_FAQ_A2]: "Open Enrollment runs November 1 – January 15 in most states. After a life event (marriage, baby, job loss, moving) you may qualify for a Special Enrollment Period any time of year.",
            [INS_FAQ_Q3]: "I'm self-employed. Can I still get health insurance?",
            [INS_FAQ_A3]: "Yes. Many self-employed clients qualify for ACA Marketplace plans with subsidies. We calculate your estimated savings before you commit.",
            [INS_FAQ_Q4]: "What's the difference between term and whole life insurance?",
            [INS_FAQ_A4]: "Term life covers a set number of years at lower cost — great for protecting young families. Whole life lasts a lifetime and builds cash value you can borrow from.",
            [INS_FAQ_Q5]: "Do you help with Medicare?",
            [INS_FAQ_A5]: "Yes. We guide seniors through Original Medicare, Advantage and Supplement plans, plus Part D drug coverage — in English or Spanish.",
        },
        cta: {
            [INS_CTA_TITLE]: "Ready to compare insurance plans?",
            [INS_CTA_SUBTITLE]: "Bring your info — we'll show you the real numbers.",
            [INS_CTA_BUTTON]: "Call now",
        },
    },
};

export default en_insurance_page;
